import React from 'react';
// import * as firebase from 'firebase'

import { NavLink } from 'react-router-dom';

import {
	Divider,
	List,
	ListItem,
	ListItemIcon,
	ListItemText
} from 'material-ui';

import AccountBoxIcon from 'material-ui-icons/AccountBox';
import WorkIcon from 'material-ui-icons/Work';
import NoteAddIcon from 'material-ui-icons/NoteAdd';
// import LocalOfferIcon from 'material-ui-icons/LocalOffer'
import ContentPasteIcon from 'material-ui-icons/ContentPaste';
import LocalAtmIcon from 'material-ui-icons/LocalAtm';
// import FormatListNumberedIcon from 'material-ui-icons/FormatListNumbered'
import ExitToAppIcon from 'material-ui-icons/ExitToApp';
import PaymentIcon from 'material-ui-icons/Payment';
import FavoriteBorderIcon from 'material-ui-icons/FavoriteBorder';
import ShareIcon from 'material-ui-icons/Share';
import ChatBubbleOutlineIcon from 'material-ui-icons/ChatBubbleOutline';
import GroupAddIcon from 'material-ui-icons/GroupAdd';
import SettingsIcon from 'material-ui-icons/Settings';
import DashboardIcon from 'material-ui-icons/Dashboard';

// import LogoutBtn from './LogoutBtn'
import { Logout } from '../helper/functions';

const style = {
	menuList: {
		display: 'flex',
		height: 'calc(100vh - 64px)',
		// marginTop:'64px',
		flexDirection: 'column',
		backgroundColor: '#ffffff',
		width: '250px',
		paddingBottom: '0'
		// borderRight:'1px solid rgba(0,0,0,0.2)'
	},
	space: {
		flex: '1 1 auto'
	}
};

export default class Nav extends React.Component {
	render() {
		const { admin, mini } = this.props;
		// console.log(this.props);
		// console.log(window.location.hash.split('/')[1]);
		if (!!admin) {
			return (
				<List style={style.menuList}>
					<ListItem disabled button>
						{!mini && <ListItemText primary="Admin" />}
					</ListItem>

					<Divider light />

					<NavLink to={`/Admin`}>
						<ListItem
							button
							className={
								this.props.location.pathname === `/Admin` && 'selectedNavItem'
							}
						>
							<ListItemIcon>
								<DashboardIcon />
							</ListItemIcon>
							{!mini && <ListItemText primary="Dashboard" />}
						</ListItem>
					</NavLink>

					<NavLink to={`/Jobs`}>
						<ListItem
							button
							className={
								this.props.location.pathname === `/Jobs` && 'selectedNavItem'
							}
						>
							<ListItemIcon>
								<WorkIcon />
							</ListItemIcon>
							{!mini && <ListItemText primary="Jobs" />}
						</ListItem>
					</NavLink>

					<NavLink to={`/AddJob`}>
						<ListItem
							button
							className={
								this.props.location.pathname === `/AddJob` && 'selectedNavItem'
							}
						>
							<ListItemIcon>
								<NoteAddIcon />
							</ListItemIcon>
							{!mini && <ListItemText primary="Add Job" />}
						</ListItem>
					</NavLink>

					<NavLink to={`/BatchInvites`}>
						<ListItem
							button
							className={
								this.props.location.pathname === `/BatchInvites` &&
								'selectedNavItem'
							}
						>
							<ListItemIcon>
								<GroupAddIcon />
							</ListItemIcon>
							{!mini && <ListItemText primary="Batch Invites" />}
						</ListItem>
					</NavLink>

					<NavLink to={`/Payouts`}>
						<ListItem
							button
							className={
								this.props.location.pathname === `/Payouts` && 'selectedNavItem'
							}
						>
							<ListItemIcon>
								<PaymentIcon />
							</ListItemIcon>
							{!mini && <ListItemText primary="Payouts" />}
						</ListItem>
					</NavLink>

					<div style={style.space} />

					<Divider light />

					<NavLink to={`/Settings`}>
						<ListItem
							button
							className={
								this.props.location.pathname === `/Settings` &&
								'selectedNavItem'
							}
						>
							<ListItemIcon>
								<SettingsIcon />
							</ListItemIcon>
							{!mini && <ListItemText primary="Settings" />}
						</ListItem>
					</NavLink>

					<ListItem onClick={Logout} button>
						<ListItemIcon>
							<ExitToAppIcon />
						</ListItemIcon>
						{!mini && <ListItemText primary="Logout" />}
					</ListItem>
				</List>
			);
		}

		if (!admin) {
			return (
				<List style={style.menuList}>
					<ListItem disabled button>
						{!mini && <ListItemText primary="My Stuff" />}
					</ListItem>
					<Divider light />
					<NavLink to={`/Dashboard`}>
						<ListItem
							button
							className={
								this.props.location.pathname === `/Dashboard` &&
								'selectedNavItem'
							}
						>
							<ListItemIcon>
								<DashboardIcon />
							</ListItemIcon>
							{!mini && <ListItemText primary="Dashboard" />}
						</ListItem>
					</NavLink>

					<NavLink to={`/Profile`}>
						<ListItem
							button
							className={
								this.props.location.pathname === `/Profile` && 'selectedNavItem'
							}
						>
							<ListItemIcon>
								<AccountBoxIcon />
							</ListItemIcon>
							{!mini && <ListItemText primary="Profile" />}
						</ListItem>
					</NavLink>

					<NavLink to={`/Invites`}>
						<ListItem
							button
							className={
								this.props.location.pathname === `/Invites` && 'selectedNavItem'
							}
						>
							<ListItemIcon>
								<ShareIcon />
							</ListItemIcon>
							{!mini && <ListItemText primary="Invites" />}
						</ListItem>
					</NavLink>

					<NavLink to={`/Applications`}>
						<ListItem
							button
							className={
								this.props.location.pathname === `/Applications` &&
								'selectedNavItem'
							}
						>
							<ListItemIcon>
								<ContentPasteIcon />
							</ListItemIcon>
							{!mini && <ListItemText primary="Applications" />}
						</ListItem>
					</NavLink>

					<NavLink to={`/Commissions`}>
						<ListItem
							button
							className={
								this.props.location.pathname === `/Commissions` &&
								'selectedNavItem'
							}
						>
							<ListItemIcon>
								<LocalAtmIcon />
							</ListItemIcon>
							{!mini && <ListItemText primary="Commissions" />}
						</ListItem>
					</NavLink>

					<NavLink to={`/Favorites`}>
						<ListItem
							button
							className={
								this.props.location.pathname === `/Favorites` &&
								'selectedNavItem'
							}
						>
							<ListItemIcon>
								<FavoriteBorderIcon />
							</ListItemIcon>
							{!mini && <ListItemText primary="Favorites" />}
						</ListItem>
					</NavLink>

					<NavLink to={`/Chats`}>
						<ListItem
							button
							className={
								this.props.location.pathname === `/Chats` && 'selectedNavItem'
							}
						>
							<ListItemIcon>
								<ChatBubbleOutlineIcon />
							</ListItemIcon>
							{!mini && <ListItemText primary="Chats" />}
						</ListItem>
					</NavLink>

					<div style={style.space} />

					<Divider light />

					<NavLink to={`/Settings`}>
						<ListItem
							button
							className={
								this.props.location.pathname === `/Settings` &&
								'selectedNavItem'
							}
						>
							<ListItemIcon>
								<SettingsIcon />
							</ListItemIcon>
							{!mini && <ListItemText primary="Settings" />}
						</ListItem>
					</NavLink>

					<ListItem onClick={Logout} button>
						<ListItemIcon>
							<ExitToAppIcon />
						</ListItemIcon>
						{!mini && <ListItemText primary="Logout" />}
					</ListItem>
				</List>
			);
		}
	}
}



// WEBPACK FOOTER //
// ./src/components/Nav.js